import { render, staticRenderFns } from "./AMSUpload.vue?vue&type=template&id=bafd46a4&scoped=true&"
import script from "./AMSUpload.vue?vue&type=script&lang=ts&"
export * from "./AMSUpload.vue?vue&type=script&lang=ts&"
import style0 from "./AMSUpload.vue?vue&type=style&index=0&id=bafd46a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafd46a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
